import { Component, OnInit } from '@angular/core';
import { DepartmentBase } from '../department.base';

@Component({
  selector: 'dpto-99',
  templateUrl: './dpto99.component.html',
  styleUrls: ['../department/department.component.css']
})
export class Dpto99Component extends DepartmentBase {
  municipalities=[{"id":1119,"code":"99001","name":"Puerto Carre\u00f1o","state":"1","department_code":"99"},{"id":1120,"code":"99524","name":"La Primavera","state":"1","department_code":"99"},{"id":1121,"code":"99624","name":"Santa Rosal\u00eda","state":"1","department_code":"99"},{"id":1122,"code":"99773","name":"Cumaribo","state":"1","department_code":"99"}]
}
